import { useQuery } from '@apollo/client/react'
import {
  PortalBusinessPackagesDocument,
  type PortalBusinessPackagesQuery,
} from '@/graphql/generated/graphql'

export type BusinessPackage =
  PortalBusinessPackagesQuery['portalBusinessPackages'][number]

/**
 * Servicios contratados por un negocio. `cache-first`: carga una vez; las altas
 * y bajas se reflejan vía el `refetchQueries` de las mutaciones, y el usuario
 * puede recargar con el botón de refresh.
 */
export function useBusinessPackages(businessId: string | undefined) {
  const { data, loading, error, refetch } = useQuery(PortalBusinessPackagesDocument, {
    variables: { businessId: businessId ?? '' },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    packages: data?.portalBusinessPackages ?? [],
    loading,
    error,
    refetch,
  }
}
